import {
  CallState,
  HotelEntryTypeEnum,
  ICategorizedResponse,
  IResult,
  Lodging,
  RoomInfoProducts,
  TrackingProperties,
  DateRange,
  CorpLodging,
  CorpRoomInfoProducts,
  CancellationSummary,
  HotelDetailsEntrySourceEnum,
  LodgingTokenResponse,
  IPersistentLodgingTrackingProperties,
  LodgingSelection,
  HotelCrossSellTrackingProperties,
} from "redmond";

export interface IHotelShopState {
  selectedLodging: Lodging | CorpLodging | null;
  dateRange: DateRange | null;
  roomInfoProducts: RoomInfoProducts[] | CorpRoomInfoProducts[];
  hotelShopTrackingPropertiesV2: TrackingProperties | null;
  chosenRoomInfoIndex: number | null;
  chosenProductIndex: number | null;
  hotelShopCallState: HotelShopCallState;
  hotelShopCallError: HotelShopCallError | null;
  progress: HotelShopStep;
  similarHotels: Lodging[] | CorpLodging[];
  similarHotelsAvailabilityCallState: CallState;
  similarHotelsAvailabilityTrackingProperties: TrackingProperties | null;
  nearbyLodgings: Lodging[] | CorpLodging[];
  nearbyLodgingsAvailabilityCallState: CallState;
  distanceFromLocation: IResult | null;
  distanceFromLocationCategories: ICategorizedResponse[];
  distanceFromLocationCategoriesLoading: boolean | null;
  entryPoint?: HotelEntryTypeEnum;
  selectedRoomId?: string;
  chosenRateId?: string;
  recommendedBasedOnPreferences?: boolean;
  cancellationSummary: CancellationSummary | null;
  hotelDetailsEntrySource?: HotelDetailsEntrySourceEnum;
  cacheLodgingTokenResponse?: LodgingTokenResponse;
  sortOrder: string | undefined;
  selectedLodgingIsFavorited?: boolean;
  persistentLodgingTrackingProperties?: IPersistentLodgingTrackingProperties;
  hotelShopLodgingSelection?: LodgingSelection;
  crossSellTrackingProperties?: HotelCrossSellTrackingProperties;
}

export enum HotelShopStep {
  HotelInfo = "hotel-info-step",
  ChooseRoom = "choose-room-step",
}

export enum HotelShopCallState {
  NotCalled = "NotCalled",
  InProcess = "InProcess",
  Success = "Success",
  Failed = "Failed",
  FailureAcknowledged = "FailureAcknowledged",
}

export enum HotelShopCallError {
  NoAvailability = "NoAvailability",
  Unknown = "Unknown",
}
